import React, { useEffect, useState } from 'react';

import { track } from '@betterment/js-runtime';
import { Box, Icon, Text } from '@betterment/samba-react';
import { Button, CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';

import Footer from '../Shared/components/Footer';
import { MFA_LOCKED_SUPPORT_PHONE } from '../Shared/constants';
import { locationAssign } from '../Shared/path-helpers';
import { urlBuilder } from '../Shared/urlBuilder';

interface Props {
  senderFirstName: string;
}

const PrimaryBadState: React.FC<React.PropsWithChildren<Props>> = ({ senderFirstName }) => {
  useEffect(() => {
    track('ElementViewed', { name: 'PrimaryBadState', flow: 'OpenJointCheckingSecondary' });
  }, []);

  const [isSubmitting, setSubmitting] = useState(false);

  const onAck = () => {
    setSubmitting(true);
    track('ElementClicked', { name: 'GotIt', flow: 'OpenJointCheckingSecondary' });
    locationAssign(urlBuilder.appHome.absolute());
  };

  return (
    <CenteredWorkflowLayout title="Joint Checking signup">
      <CenteredWorkflowLayout.Slot name="content">
        <Box
          css={{
            marginBottom: 'space.300',
          }}
        >
          <Icon name="ExclamationCircle" size="large" color="icon" />
        </Box>
        <Heading as="h1" variant="primary">
          One of {senderFirstName}'s accounts with us isn't in good standing
        </Heading>
        <Box
          css={{
            marginBottom: 'space.400',
          }}
        >
          <Text as="p">They'll need to resolve the matter before you can open your Joint Checking account.</Text>
          <Text as="p">
            Please have them call us at <a href={`tel:${MFA_LOCKED_SUPPORT_PHONE}`}>{MFA_LOCKED_SUPPORT_PHONE}</a> so we
            can assist them.
          </Text>
        </Box>
        <CenteredWorkflowLayout.Actions>
          <Button type="button" px="8" onClick={onAck} disabled={isSubmitting}>
            Got it
          </Button>
        </CenteredWorkflowLayout.Actions>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default PrimaryBadState;
